module.exports = __webpack_public_path__ + "media/blog/linkedin-ebd40f68.png";